import { company } from '@/config/company';

/** Builds the service enquiry email destination from the shared business contact. */
export function useServiceInquiry(serviceTitle?: string) {
  const subject = serviceTitle
    ? `Question about ${serviceTitle}`
    : 'Question about Kabex Motors services';

  return {
    href: `mailto:${company.inquiryEmail}?subject=${encodeURIComponent(subject)}`,
    label: serviceTitle ? 'Email about this service' : 'Email us about a service',
  };
}
